import * as CryptoJS from "crypto-js";
import crypto from "crypto";
import { getCookie } from "../util/session-cookie.util";

export const encryptData = (data, ns = null) => {
  return new Promise((resolve, reject) => {
    try {
      const NS = ns ?? getCookie("sessionKey"),
        salt = CryptoJS.lib.WordArray.random(256),
        iterations = 999,
        iv = CryptoJS.lib.WordArray.random(16);

      var key = CryptoJS.PBKDF2(NS, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: iterations,
      });

      var encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
      });

      var transitmessage = {
        ciphertext: encrypted.toString(),
        salt: salt.toString(),
        iv: iv.toString(),
      };

      resolve(transitmessage);
    } catch (err) {
      ////console.log(err);
      reject(err);
    }
  });
};

export const decryptData = (encryptedData, ns = null) => {
  return new Promise((resolve, reject) => {
    try {
      const NS = ns ?? getCookie("sessionKey"),
        obj_json = encryptedData;

      // //console.log("data for decrypt", encryptedData);
      // resolve(true);
      var encrypted = obj_json.ciphertext;
      var salt = CryptoJS.enc.Hex.parse(obj_json.salt);
      var iv = CryptoJS.enc.Hex.parse(obj_json.iv);
      var key = CryptoJS.PBKDF2(NS, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999,
      });

      var decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv });

      let Resp = decrypted.toString(CryptoJS.enc.Utf8);

      resolve(JSON.parse(Resp));
    } catch (err) {
      //console.log(err);
      reject(err);
    }
  });
};

export function generateNS() {
  const bytes = crypto.randomBytes(16);

  // UUID v4
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = bytes.toString("hex");

  return [
    hex.substring(0, 8),
    hex.substring(8, 12),
    hex.substring(12, 16),
    hex.substring(16, 20),
    hex.substring(20, 32),
  ].join("-");
}
